/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
let galleryThumbClick = () => {
    let elementsArray = document.querySelectorAll("[data-video-media-id]");
    elementsArray.forEach(element => {
        element.onclick = () => {
            let video_id = element.getAttribute('data-video-media-id')
            setTimeout(() => {
                document.getElementById(video_id).play()
            }, 333);
        }
    });
}

let paginationCheck = () => {
    let paginationList = document.querySelectorAll('.pagination__nav');
    paginationList.forEach(paginationWrap => {
        let paginationList = paginationWrap.querySelectorAll('.pagination__nav-item');
        paginationList.forEach(paginationItem => {
            if (!paginationItem.disabled) {
                paginationItem.onclick = () => {
                    paginationList.forEach(item => {
                        item.classList.remove('is-active');
                        item.disabled = false;
                    });
                    paginationItem.classList.add('is-active');
                    paginationItem.disabled = true;
                }
            }
        });
    });
}

(function (history) {
    var pushState = history.pushState;
    history.pushState = function (state) {
        var url = new URL(arguments[2]);
        var params = new URLSearchParams(url.search);
        let curentPage = params.get('page');
        let itemList = document.querySelectorAll('.pagination__nav-item[data-page]');
        let currentPageItem = document.querySelector(`.pagination__nav-item[data-page='${curentPage}']`);
        let prevPagination = document.querySelector(`.pagination__prev`);
        let nextPagination = document.querySelector(`.pagination__next`);
        itemList.forEach(item => {
            item.classList.remove('is-active');
            item.disabled = false;
        });
        if(!!currentPageItem){
            currentPageItem.classList.add('is-active');
            currentPageItem.disabled = true;
        }
        if(!!prevPagination){
            prevPagination.setAttribute('data-page', parseInt(curentPage) - 1)
        }
        if(!!nextPagination){
            nextPagination.setAttribute('data-page', parseInt(curentPage) + 1)
        }
        return pushState.apply(history, arguments);
    };
})(window.history);

let tester = () =>{
console.log('Shopify',Shopify);
    Shopify.onItemAdded = function(line_item) {
        console.log('line item added');
    };
    Shopify.onCartUpdate = function(cart) {
        console.log('There are now ' + cart.item_count + ' items in the cart.');
    };
}

tester();
paginationCheck();

galleryThumbClick();
